import { JargonPageStoryContent } from '../types'

export const isJargonHubStoryContent = (
  input: unknown,
): input is JargonPageStoryContent => {
  const isJargonPage =
    Object.prototype.hasOwnProperty.call(input, 'component') &&
    (input as JargonPageStoryContent).component === 'JargonPage'

  if (!isJargonPage) {
    console.error(
      `Expected to find JargonPage component, instead received: \n ${JSON.stringify(
        input,
        null,
        2,
      )}`,
    )
  }

  return isJargonPage
}
